import React from 'react';

/**
 * Reusable Loading Spinner Component
 * @param {string} text - Optional loading message
 * @param {boolean} fullHeight - Whether to center within the viewport (min-h-[75vh]) or use a default height (h-64)
 */
const Loader = ({ text = "Loading...", fullHeight = true }) => {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${fullHeight ? 'min-h-[75vh]' : 'h-64'}`}>
      <svg className="animate-spin h-12 w-12 text-blue-600" viewBox="0 0 24 24">
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4" 
          fill="none" 
        />
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" 
        />
      </svg>
      {text && (
        <p className="text-gray-500 dark:text-gray-400 font-medium animate-pulse">
          {text}
        </p>
      )}
    </div>
  );
};

export default Loader;
